export default "__VITE_ASSET__331efa77__"